import { useEffect, useState } from "react";
import "./PartnerListings.css";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { publicAds } from "./partnerApi";

const TYPES = [
  { v: "", l: "All" }, { v: "hotel", l: "🏨 Hotels" }, { v: "cottage", l: "🏡 Cottages" },
  { v: "homestay", l: "🏠 Homestays" }, { v: "resort", l: "🌴 Resorts" }, { v: "vehicle", l: "🚗 Vehicles" },
];
const inr = (n) => "₹" + Number(n || 0).toLocaleString("en-IN");

function AdCard({ ad }) {
  const [idx, setIdx] = useState(0);
  const photos = ad.photos?.length ? ad.photos : [];
  const wa = (ad.contactWhatsapp || ad.contactPhone || "").replace(/\D/g, "");
  return (
    <article className="pl-card">
      <div className="pl-card-media">
        {photos.length > 0 ? (
          <>
            <img src={photos[idx]} alt={ad.title} />
            {photos.length > 1 && (
              <>
                <button className="pl-nav prev" onClick={() => setIdx((idx - 1 + photos.length) % photos.length)}>‹</button>
                <button className="pl-nav next" onClick={() => setIdx((idx + 1) % photos.length)}>›</button>
                <div className="pl-dots">{photos.map((_, i) => <span key={i} className={i === idx ? "on" : ""} />)}</div>
              </>
            )}
          </>
        ) : <div className="pl-noimg">No photo</div>}
        {ad.featured && <span className="pl-featured">⭐ Featured</span>}
        <span className="pl-type">{TYPES.find((t) => t.v === ad.businessType)?.l || ad.businessType}</span>
      </div>
      <div className="pl-card-body">
        <h3>{ad.title}</h3>
        {ad.location && <p className="pl-loc">📍 {ad.location}</p>}
        {ad.description && <p className="pl-desc">{ad.description}</p>}
        {ad.amenities?.length > 0 && (
          <ul className="pl-amen">{ad.amenities.slice(0, 6).map((a, i) => <li key={i}>{a}</li>)}</ul>
        )}
        {ad.videoUrl && <video src={ad.videoUrl} controls className="pl-vid" />}
        <div className="pl-card-foot">
          {ad.priceFrom > 0 && <div className="pl-price">{inr(ad.priceFrom)} <span>{ad.priceUnit}</span></div>}
          <div className="pl-actions">
            {wa && <a className="pl-btn wa" href={`https://wa.me/91${wa}?text=${encodeURIComponent(`Hi, I'm interested in "${ad.title}" listed on OotyGo.`)}`} target="_blank" rel="noopener noreferrer">💬 Enquire</a>}
            {ad.contactPhone && <a className="pl-btn call" href={`tel:${ad.contactPhone}`}>📞 Call</a>}
          </div>
        </div>
      </div>
    </article>
  );
}

export default function PartnerListings() {
  const [ads, setAds] = useState(null);
  const [type, setType] = useState("");

  useEffect(() => { publicAds(type).then(setAds).catch(() => setAds([])); }, [type]);

  return (
    <>
      <Navbar />
      <div className="pl-page">
        <div className="pl-head">
          <span className="section-eyebrow">Partner Listings</span>
          <h1>Stays &amp; Rides across the Nilgiris</h1>
          <p>Hand-listed hotels, cottages, homestays &amp; vehicles from our verified local partners.</p>
          <a className="pl-list-cta" href="/partner">List your property →</a>
        </div>

        <div className="pl-filters">
          {TYPES.map((t) => (
            <button key={t.v} className={type === t.v ? "on" : ""} onClick={() => setType(t.v)}>{t.l}</button>
          ))}
        </div>

        {ads === null ? (
          <div className="pl-loading">Loading listings…</div>
        ) : ads.length === 0 ? (
          <div className="pl-empty">No listings yet in this category. <a href="/partner">Be the first to list →</a></div>
        ) : (
          <div className="pl-grid">{ads.map((ad) => <AdCard key={ad.id} ad={ad} />)}</div>
        )}
      </div>
      <Footer />
    </>
  );
}
